
import {Options, Vue} from 'vue-class-component';

@Options({
    components: {
    },
    created() {
    }
})
export default class App extends Vue {

}
